import { useGetCurrentSubscriptionsQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.hooks';
import { useGetCurrentSubscriptionsQuery as usePreviewGetCurrentSubscriptionsQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerPreviewDataRpc.hooks';
import { getPreviewState } from '../utils/getPreviewState';
export function useSubscriptionsData() {
  var _data$results;
  const previewState = getPreviewState();
  const previewJwt = previewState.isPreview ? previewState.previewJwt : '';
  const {
    loading: previewLoading,
    error: previewError,
    data: previewData
  } = usePreviewGetCurrentSubscriptionsQuery({
    variables: {
      previewJwt
    },
    skip: !previewState.isPreview
  });
  const {
    loading,
    error,
    data
  } = useGetCurrentSubscriptionsQuery({
    skip: previewState.isPreview
  });
  if (previewState.isPreview) {
    var _previewData$results;
    return {
      loading: previewLoading,
      error: previewError,
      data: (_previewData$results = previewData === null || previewData === void 0 ? void 0 : previewData.results) !== null && _previewData$results !== void 0 ? _previewData$results : []
    };
  }
  return {
    loading,
    error,
    data: (_data$results = data === null || data === void 0 ? void 0 : data.results) !== null && _data$results !== void 0 ? _data$results : []
  };
}